module.exports = __webpack_public_path__ + "img/target3.1b546c8d.jpg";